export default __webpack_public_path__ + "static/media/m-stake-arrow.cf5b764d.svg";